export default __webpack_public_path__ + "static/media/untitled.16996107.txt";